import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {GlobalService} from 'app/global/global.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {RoleDetail} from '../signing-page/signing-page.dto';
import {DocumentKey} from './document-key.enum';
import {DocumentKeyService} from './documnet-key.service';

@Component({
  selector: 'app-document-key',
  templateUrl: './document-key.component.html',
  styleUrl: './document-key.component.scss'
})
export class DocumentKeyComponent {
  @Input() roleDetail: RoleDetail
  constructor(
    private documentKeyService: DocumentKeyService,
    private globalService: GlobalService,
    private deviceService: DeviceDetectorService,
    private activeModal: NgbActiveModal,
  ) { }
  public documentKey = DocumentKey;
  public password: string = '';
  public loaders = { password: false, pin_code: false, bank_id: false };
  private enums = {password: 'password', pin_code:"dk_pin_code"};
  public sentPinCode:boolean = false;

  /**
   * when document key is pin code
   */
  sendPinCode(){
    this.loaders[this.roleDetail.roleable.dk_type] = true;
    this.documentKeyService.sendPinCode(this.roleDetail.id, this.roleDetail.recipient.phone_no).subscribe({
      next : () => {
        this.loaders[this.roleDetail.roleable.dk_type] = false;
        this.sentPinCode = true;
      },
      error: (err) => {
        this.loaders[this.roleDetail.roleable.dk_type] = false;
        this.globalService.toastrError(err)
      }
    })
  }

  viewDocument() {
    if(!this.password){
      return;
    }
    this.loaders[this.roleDetail.roleable.dk_type] = true;
    this.documentKeyService.viewDocument(this.roleDetail.id, this.roleDetail.roleable_id, {[this.enums[this.roleDetail.roleable.dk_type]]:this.password}).subscribe({
      next: () => {
        this.activeModal.close({viewdocument:true});
        this.loaders[this.roleDetail.roleable.dk_type] = false;
      },
      error: (err) => {
        this.globalService.toastrError(err);
        this.loaders[this.roleDetail.roleable.dk_type] = false;
      }
    })
  }

  async processAuthenticate() {
    this.loaders[this.roleDetail.roleable.dk_type] = true;
    try {
      const { orderRef, autoStartToken } = await this.documentKeyService.authenticateBankid(this.roleDetail);
      const success = await this.documentKeyService.authenticateAndCollect(orderRef, autoStartToken, this.deviceService.getDeviceInfo().os);

      if (success) {
        this.activeModal.close({ viewdocument: true });
        this.loaders[this.roleDetail.roleable.dk_type] = false;
      } else {
        // Handle failure if needed
      }
    } catch (err) {
      this.loaders[this.roleDetail.roleable.dk_type] = false;
    }
  }
}
